export default "__VITE_ASSET__D_s9j7sK__"